// Get the first element that is referenced by the element's aria-describedby attribute
export const getDescribedByElement = (element) => {
  if ("ariaDescribedByElements" in element) {
    return element.ariaDescribedByElements[0];
  }
  const describedByElementId =
    element.getAttribute("aria-describedby")?.split(/\s+/) || null;
  if (!describedByElementId) return null;
  return document.getElementById(describedByElementId[0]);
};
